import './sequenceblock.less'

import {SequenceModel} from 'models/program/SequenceModel'
import {SequenceSessionModel} from 'models/program/SequenceSessionModel'
import {SummitsLinkType} from 'pages'
import React, {useState} from 'react'
import AnimateHeight from 'react-animate-height'
import {Mod, style} from 'util/style'
import {
	Programblock,
	ProgramblockContent,
	ProgramblockTime,
	ProgramblockTimeline
} from 'views/program/blocks/programblock'
import {ProgramLink} from 'views/program/programlink'

const styles = style('sequenceblock')

export const Sequenceblock: React.FC<{
	sequence: SequenceModel
	mod?: Mod<'sub' | 'session' | 'sequence' | 'breakout'>
	summits_link?: SummitsLinkType
}> = ({sequence, mod = 'sequence', summits_link}) => {
	const [open, setOpen] = useState(true)
	const {title, start_time, end_time} = sequence

	return (
		<div className={styles().is({open})}>
			<div onClick={() => setOpen(!open)}>
				<Programblock has_down={sequence.sessions.length > 0} mod={mod}>
					<ProgramblockTime start_time={start_time} end_time={end_time} />
					<ProgramblockContent title={title} summits_link={summits_link} />
				</Programblock>
			</div>
			{sequence.sessions.length > 0 && (
				<AnimateHeight height={open ? 'auto' : 0} animateOpacity={true}>
					<div className={styles('sequence')}>
						{sequence.sessions.map(session => (
							<div className={styles('sequence-item')}>
								<SequenceblockSession
									session={session}
									mod={mod}
									summits_link={summits_link}
								/>
								<ProgramLink
									item={session}
									style={{position: 'absolute', inset: 0}}
								/>
							</div>
						))}
					</div>
				</AnimateHeight>
			)}
		</div>
	)
}

export const SequenceblockSession: React.FC<{
	session: SequenceSessionModel
	mod?: Mod<'sub' | 'session' | 'sequence' | 'breakout'>
	summits_link?: SummitsLinkType
}> = ({session, mod = 'sequence', summits_link}) => {
	const {title, start_time, shortDescription, summits} = session

	return (
		<Programblock mod="sub">
			<ProgramblockTimeline start_time={start_time} mod={mod} />
			<ProgramblockContent
				title={title}
				short_desc={shortDescription}
				summits={summits}
				mod={start_time ? 'start' : undefined}
				summits_link={summits_link}
			/>
		</Programblock>
	)
}
